import Token from '@/di/di.token'

import useService from './useService'

export default function useTagService() {
  const { service } = useService(Token.TAG_SERVICE)
  return { service }
}
